// extracted by mini-css-extract-plugin
export default {"rawMessage":"gX9nYG6mnp92Q1FIzI2D"};